<template>
    <div>
        <template v-if="!loading">
            <template v-if="manager.tipo == 1">
                <LayoutSports :event_id="event_id" :sesion_id="sesion_id" :event="event"/>
            </template>
            <template v-if="manager.tipo == 2">
                <LayoutTeatros :event="event" :entradas="entradas" :event_id="event_id" :sesion_id="sesion_id"/>
            </template>
        </template>
        <template v-else>
            <div class="col-12 text-center" style="height: 600px">
                <LoaderComponent/>
            </div>
        </template>
        <AficionVisitanteModal
            :name="modalName"
            @close="onAficionVisitanteClose"
        />
    </div>
</template>

<script>
    import LayoutSports from './layouts/show/Sports';
    import LayoutTeatros from './layouts/show/Teatros';
    import { useEventoTracking } from '@/composables/front/analytics/useEventoTracking';
    import AficionVisitanteModal from '@/views/frontend/events/layouts/index/modals/AficionVisitanteModal.vue';
    import {
        isAficionVisitanteTheater,
        AFICION_VISITANTE_MODAL_NAME
    } from '@/composables/front/events/useAficionVisitanteTheater';

    export default {
        props: ['event_id', 'sesion_id'],
        components: {
            LayoutSports,
            LayoutTeatros,
            AficionVisitanteModal,
        },
        data() {
            return {
                loading: false,
                event: null,
                entradas: null
            }
        },
        computed : {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            user() {
                return this.$store.getters.getUser;
            },
            modalName() {
                // Vue 2 Options API no expone constantes de módulo en el
                // template; las exponemos como computed para mantener una
                // única fuente de verdad en `useAficionVisitanteTheater`.
                return AFICION_VISITANTE_MODAL_NAME;
            },
            checkVentaCerrada() {
                if (
                    (this.event.venta_online_cerrada || this.event.venta_online_cerrada_definitiva || this.event.status != 1) &&
                    (
                        document.location.href.indexOf('venta_online=test') === -1 &&
                        document.location.href.indexOf('venta_online=preventa-53578') === -1
                    ) &&
                    (
                        this.configuracion.hash_teatro !== "PTNL6tp97mBUGDchX6d4" ||
                        document.location.href.indexOf('venta_online=preventa-53578') === -1
                    )
                ) {
                    return false;
                } else {
                    return true
                }
            }
        },
        created() {
            this.getEvent();
        },
        methods: {
            getEvent() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    event_id: this.event_id,
                    sesion_id: this.sesion_id
                }
        
                this.$store.dispatch(this.config.getVuexAlias('front.events.show'), params).then(res => {
                    this.event = res.data.data;
                    this.entradas = this.event.entradas;
                    this.loading = false;
                    const ruta = this.event.experiencia ? 'front.experiencias.index' : 'front.eventos.index';
                    if (this.event.preventa?.registro_preventa_activo && !this.event.preventa?.registrado_en_preventa) {
                        this.$router.push({ name: 'front.eventos.registro-preventa', params: { event_id: this.event.id, sesion_id: this.sesion_id } });
                        return;
                    }

                    if (this.event.preventa?.venta_preventa_activa) {
                        if (!this.user || !this.event.preventa?.puede_comprar_en_preventa) {
                            this.$router.push({ name: ruta });
                        }
                    } else if(!this.eventCanBeShown()) {
                        this.$router.push({ name: ruta });
                    } else {
                        this.mostrarAvisoAficionVisitante();
                        this.enviarEventoGA4();
                    }



                }).catch(error => {
                    this.$router.push({ name: '404page' });
                    this.loading = false;
                });
            },
            eventCanBeShown() {
                const fechaActual = new Date().toISOString().split('T')[0];
                const eventoPasado = this.event.fecha_sesion < fechaActual && this.event.fecha_fin_sesion < fechaActual;

                const eventoNoDisponible = 
                    (this.event.solo_abonados && !this.event.lfp_id) ||
                    !this.checkVentaCerrada ||
                    this.event.entradas_agotadas_online;

                return !(eventoPasado || eventoNoDisponible);
            },
            enviarEventoGA4() {
                /**
                 * Map event from API format to GA4 format
                 * Transforms: { id, name, precio_minimo, ... } → { evento_id, evento_name, price, ... }
                 */
                const { trackViewItem } = useEventoTracking({ store: this.$store, getVuexAlias: this.config.getVuexAlias });

                const mappedEvento = {
                    evento_id: this.event.id,
                    evento_name: this.event.name,
                    price: this.event.precio_minimo || 0,
                };

                trackViewItem(mappedEvento);
            },
            mostrarAvisoAficionVisitante() {
                // Solo aplica en el teatro del cliente. La URL eventos/:event_id/:sesion_id
                // es la pantalla de compra, por lo que el modal aparece al comprar una
                // entrada en cualquier evento de ese teatro.
                //
                // La regla vive en `useAficionVisitanteTheater` para evitar que el
                // hash objetivo se filtre por la vista de compra; este método solo
                // consulta la elegibilidad y delega la apertura al modal.
                if (!isAficionVisitanteTheater(this.configuracion?.hash_teatro)) return;

                this.$nextTick(() => {
                    this.$modal.show(AFICION_VISITANTE_MODAL_NAME);
                });
            },
            onAficionVisitanteClose() {
                // El modal es presentacional: emite `close` y el padre orquesta
                // el cierre con vue-js-modal para mantener una única fuente de
                // verdad del nombre del modal en `useAficionVisitanteTheater`.
                this.$modal.hide(AFICION_VISITANTE_MODAL_NAME);
            }
        }
    }
</script>
